import { navTranslations } from '@/translations/nav';
import { heroTranslations } from '@/translations/hero';
import { featuresTranslations } from '@/translations/features';
import { foodShowcaseTranslations } from '@/translations/foodShowcase';
import { aboutUsTranslations } from '@/translations/aboutUs';
import { callToActionTranslations } from '@/translations/callToAction';
import { footerTranslations } from '@/translations/footer';
import { menuPageTranslations } from '@/translations/menuPage';
import { cateringPageTranslations } from '@/translations/cateringPage';
import { marketDayPageTranslations } from '@/translations/marketDayPage';
import { contactPageTranslations } from '@/translations/contactPage';
import { orderModalTranslations } from '@/translations/orderModal';

export const translations = {
  nl: {
    nav: navTranslations.nl,
    hero: heroTranslations.nl,
    features: featuresTranslations.nl,
    foodShowcase: foodShowcaseTranslations.nl,
    aboutUs: aboutUsTranslations.nl,
    callToAction: callToActionTranslations.nl,
    footer: footerTranslations.nl,
    menuPage: menuPageTranslations.nl,
    cateringPage: cateringPageTranslations.nl,
    marketDayPage: marketDayPageTranslations.nl,
    contactPage: contactPageTranslations.nl,
    orderModal: orderModalTranslations.nl,
  },
  en: {
    nav: navTranslations.en,
    hero: heroTranslations.en,
    features: featuresTranslations.en,
    foodShowcase: foodShowcaseTranslations.en,
    aboutUs: aboutUsTranslations.en,
    callToAction: callToActionTranslations.en,
    footer: footerTranslations.en,
    menuPage: menuPageTranslations.en,
    cateringPage: cateringPageTranslations.en,
    marketDayPage: marketDayPageTranslations.en,
    contactPage: contactPageTranslations.en,
    orderModal: orderModalTranslations.en,
  },
};